import { graphql } from "gatsby"
import GatsbyImage, { FluidObject } from "gatsby-image"
import React from "react"
import { css } from "styled-components"
import mergeVariants, { TVariantProp } from "../util/merge-variants"
import VariantContainer from "./variant-container"

export const CONTENTFUL_ASSET_TYPENAME = "ContentfulAsset"

export interface IContentfulAsset {
  __typename: typeof CONTENTFUL_ASSET_TYPENAME
  file: {
    url: string
    contentType: string
    details: {
      image?: {
        height?: string
        width?: string
      }
    }
  }
  fluid?: FluidObject
  description?: string
  variants?: TVariantProp
}

interface ContentfulAssetProps extends Omit<IContentfulAsset, "__typename"> {}

const ContentfulAsset = ({
  file,
  fluid,
  description = "",
  variants,
}: ContentfulAssetProps) => {
  const type = file?.contentType?.split("/")?.[0] || ""
  return type === "image" ? (
    <VariantContainer
      variants={mergeVariants(
        [
          css`
            max-height: ${`${file?.details?.image?.height}px` || "100%"};
            max-width: ${`${file?.details?.image?.width}px` || "100%"};
          `,
        ],
        variants
      )}
    >
      {fluid ? (
        <GatsbyImage fluid={fluid} alt={description} />
      ) : (
        <img
          src={`https:${file?.url}`}
          alt={description}
          height={file?.details?.image?.height}
          width={file?.details?.image?.width}
        />
      )}
    </VariantContainer>
  ) : null // for now we're only handling images and other assets are ignored
}

export const ContentfulAssetFragment = graphql`
  fragment ContentfulAsset on ContentfulAsset {
    contentful_id
    file {
      url
      contentType
      details {
        image {
          height
          width
        }
      }
    }
    fluid(quality: 90, maxWidth: 1920) {
      ...GatsbyContentfulFluid_withWebp
    }
  }
`
export default ContentfulAsset
